"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatReport = exports.isComplete = exports.compare = exports.inventory = exports.expected = exports.route = exports.routes = exports.fromExpressPath = exports.Method = exports.NAMESPACE = void 0;
const Order = __importStar(require("./order"));
exports.NAMESPACE = 'Culligan.Api.OpenApi.Parity';
exports.Method = {
    GET: 'GET',
    POST: 'POST',
    PUT: 'PUT',
    PATCH: 'PATCH',
    DELETE: 'DELETE',
    HEAD: 'HEAD',
    OPTIONS: 'OPTIONS',
};
const METHODS = new Set(Object.values(exports.Method));
const OPTIONAL_PARAM = /^:(\w+)\?$/;
/**
 * Express path syntax this converter does not model: an optional/repeat
 * modifier that is not a whole segment (`/:id?.json`, `/:path*`, `/:x+`) or
 * an inline regex constraint (`/:id(\\d+)`). Left in place, these would
 * emit malformed OpenAPI paths, so they fail loudly instead.
 */
const UNSUPPORTED_SYNTAX = /[?*+()]/;
/**
 * Converts an Express path to every OpenAPI path it serves.
 *
 * `:id` becomes `{id}`. An optional segment `:kind?` has no OpenAPI
 * equivalent, and Express matches the request both with and without it, so
 * the path expands to both variants: `/data/:kind?` yields `/data` and
 * `/data/{kind}`. That is also what the conventions ask contract authors to
 * declare, one endpoint per variant, so both inventories agree.
 *
 * Adjacent optional segments (`/:year?/:month?`) expand as prefixes only:
 * Express binds a lone segment to the first parameter, so `/{month}` with
 * `year` omitted is never served and is not produced.
 *
 * Only whole-segment optionals are expanded. Any other Express modifier or
 * constraint surviving conversion (`?`, `*`, `+`, `(...)`) throws rather than
 * producing a path OpenAPI would accept but no router serves.
 */
const fromExpressPath = (path) => {
    const paths = expand(path);
    const malformed = paths.filter(p => UNSUPPORTED_SYNTAX.test(p));
    if (malformed.length > 0) {
        throw new Error(`${exports.NAMESPACE}: "${path}" uses Express path syntax that has no OpenAPI form ` +
            `(inline optional, repeat or regex constraint); converted to ${malformed.join(', ')}. ` +
            'Only whole-segment optional parameters (`/:kind?`) are supported.');
    }
    return paths;
};
exports.fromExpressPath = fromExpressPath;
const expand = (path) => {
    let variants = [{ segments: [], omitting: false }];
    for (const segment of path.split('/')) {
        const optional = OPTIONAL_PARAM.exec(segment);
        if (optional === null) {
            const converted = segment.replace(/:(\w+)/g, '{$1}');
            variants = variants.map(v => ({ segments: [...v.segments, converted], omitting: false }));
        }
        else {
            const param = `{${optional[1]}}`;
            variants = variants.flatMap(v => v.omitting
                ? [v]
                : [
                    { segments: v.segments, omitting: true },
                    { segments: [...v.segments, param], omitting: false },
                ]);
        }
    }
    return Array.from(new Set(variants.map(v => v.segments.join('/') || '/')));
};
const toMethod = (method) => {
    const upper = method.toUpperCase();
    if (!METHODS.has(upper)) {
        throw new Error(`${exports.NAMESPACE}: unsupported HTTP method "${method}"`);
    }
    return upper;
};
/**
 * Builds every route key an Express mapping serves; the method is upper-cased
 * and optional parameters expand into one key per variant.
 */
const routes = (method, path) => {
    const upper = toMethod(method);
    return (0, exports.fromExpressPath)(path).map(p => `${upper} ${p}`);
};
exports.routes = routes;
/**
 * Builds a single route key for a path without optional parameters.
 *
 * Use {@link routes} for raw Express paths that may contain `:param?`.
 */
const route = (method, path) => {
    const all = (0, exports.routes)(method, path);
    if (all.length !== 1) {
        throw new Error(`${exports.NAMESPACE}: "${path}" has optional parameters and serves ${all.length} routes; use routes()`);
    }
    return all[0];
};
exports.route = route;
/**
 * Builds the expected inventory from legacy router mappings.
 *
 * `basePath` is the mount point (`/api`); `mappings` are `[method, path]`
 * pairs as registered by `router.get(...)` & co, e.g. `['get', '/v2/fleet']`.
 * A mapping with optional parameters contributes one route per variant.
 */
const expected = (basePath, mappings) => {
    const result = new Set();
    for (const [method, path] of mappings) {
        for (const r of (0, exports.routes)(method, `${basePath}${path}`))
            result.add(r);
    }
    return result;
};
exports.expected = expected;
/** Every `METHOD /path` pair present in a generated OpenAPI document. */
const inventory = (spec) => {
    const routes = new Set();
    for (const [path, item] of Object.entries(spec.paths)) {
        for (const method of Object.keys(item)) {
            const upper = method.toUpperCase();
            if (METHODS.has(upper))
                routes.add(`${upper} ${path}`);
        }
    }
    return routes;
};
exports.inventory = inventory;
/** Compares an expected inventory with the routes a document describes. */
const compare = (expectedRoutes, spec) => {
    const wanted = new Set(expectedRoutes);
    const actual = (0, exports.inventory)(spec);
    return {
        missing: Order.sorted(Array.from(wanted).filter(r => !actual.has(r))),
        unexpected: Order.sorted(Array.from(actual).filter(r => !wanted.has(r))),
    };
};
exports.compare = compare;
const isComplete = (report) => report.missing.length === 0 && report.unexpected.length === 0;
exports.isComplete = isComplete;
/** Multi-line, human readable summary suitable for test failure messages. */
const formatReport = (report) => {
    if ((0, exports.isComplete)(report))
        return 'Route inventory matches the OpenAPI document.';
    const lines = [];
    if (report.missing.length > 0) {
        lines.push(`Missing from OpenAPI (${report.missing.length}):`, ...report.missing.map(r => `  - ${r}`));
    }
    if (report.unexpected.length > 0) {
        lines.push(`Unexpected in OpenAPI (${report.unexpected.length}):`, ...report.unexpected.map(r => `  + ${r}`));
    }
    return lines.join('\n');
};
exports.formatReport = formatReport;
//# sourceMappingURL=parity.js.map